module.exports = __webpack_public_path__ + "img/yinhang1.892450b6.gif";